// extracted by mini-css-extract-plugin
export default {"form__itemsWrapper":"styles_form__items-wrapper__cGs+2"};